module.exports = __webpack_public_path__ + "img/balloon_coming_soon.39db94c4.png";